import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

// Editor modulo/sotto-sezioni condiviso tra permessi per ruolo e per utente.
export function togglePermModule(prev, modKey) {
  if (prev.includes(modKey)) return prev.filter((p) => p !== modKey && !p.startsWith(`${modKey}:`));
  return [...prev.filter((p) => !p.startsWith(`${modKey}:`)), modKey];
}

export function togglePermItem(prev, modules, modKey, itKey) {
  const fullKey = `${modKey}:${itKey}`;
  if (prev.includes(modKey)) {
    const mod = modules.find((m) => m.key === modKey);
    const others = mod.items.filter((it) => it.key !== itKey).map((it) => `${modKey}:${it.key}`);
    return [...prev.filter((p) => p !== modKey), ...others];
  }
  if (prev.includes(fullKey)) return prev.filter((p) => p !== fullKey);
  const next = [...prev, fullKey];
  const mod = modules.find((m) => m.key === modKey);
  const allOn = mod.items.every((it) => next.includes(`${modKey}:${it.key}`));
  return allOn ? togglePermModule(next, modKey) : next;
}

export function permCellStatus(perms, mod) {
  if (perms.includes(mod.key)) return { count: mod.items.length, total: mod.items.length, full: true };
  const c = mod.items.filter((it) => perms.includes(`${mod.key}:${it.key}`)).length;
  return { count: c, total: mod.items.length, full: false };
}

export default function PermissionEditor({ modules, selected, onChange, disabled, testPrefix }) {
  const full = (k) => selected.includes(k);
  const checked = (m, i) => selected.includes(m) || selected.includes(`${m}:${i}`);
  return (
    <div className={`space-y-3 ${disabled ? "opacity-50 pointer-events-none" : ""}`}>
      {modules.map((m) => (
        <div key={m.key} className="border border-stone-200 rounded-xl p-3">
          <label className="flex items-center gap-3 cursor-pointer" data-testid={`${testPrefix}-module-${m.key}`}>
            <Checkbox checked={full(m.key)} onCheckedChange={() => onChange(togglePermModule(selected, m.key))}/>
            <div className="font-semibold text-sm">{m.label}</div>
            <span className="text-[11px] text-stone-500">modulo completo</span>
          </label>
          <div className="mt-2 grid grid-cols-2 md:grid-cols-3 gap-2 pl-7">
            {m.items.map((it) => (
              <label key={it.key} className="flex items-center gap-2 cursor-pointer text-sm" data-testid={`${testPrefix}-item-${m.key}-${it.key}`}>
                <Checkbox checked={checked(m.key, it.key)} onCheckedChange={() => onChange(togglePermItem(selected, modules, m.key, it.key))}/>
                <span className="text-stone-700">{it.label}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
